import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import NoteTemplate from './NoteTemplate';
import './note-templates.scss';

const NoteTemplateSortable = (({ item, isSortable, isOwner }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    visibility: isDragging ? 'hidden' : 'visible',
  };

  return (
    <NoteTemplate
      {...item}
      style={style}
      isSortable={isSortable}
      key={`modal-reorder__${item.id}`}
      setNodeRef={setNodeRef}
      attributes={attributes}
      listeners={listeners}
      isOwner={isOwner}
    />
  );
});

export default NoteTemplateSortable;
